"use client";
import { useParams, useRouter, useSearchParams, useSelectedLayoutSegment } from "next/navigation";

export function CategoryMenu({ param, children }: { param: string; children: React.ReactNode }) {
  const { year } = useParams();
  const router = useRouter();
  const category = useSelectedLayoutSegment() ?? "";
  const searchParams = useSearchParams();

  const params = new URLSearchParams(searchParams.toString());
  const isSelect = param === category || (param === "index" && category === "");
  return (
    <li
      className={`${
        isSelect ? "active bg-primary rounded-md" : ""
      } flex-1 flex items-center justify-center link no-underline hover:bg-primary rounded-md`}
      onClick={() =>
        router.push(`/${year}/standings/${param === "index" ? "" : param}?${params.toString()}`, {
          scroll: false,
        })
      }
    >
      <span className="text-nowrap hover:bg-inherit">{children}</span>
    </li>
  );
}

export function LeagueMenu({ param, children }: { param: string; children: React.ReactNode }) {
  const searchParams = useSearchParams();
  const league = searchParams.get("league") ?? "";

  const params = new URLSearchParams(searchParams.toString());
  param === "all" ? params.delete("league") : params.set("league", param);
  const isSelect = param === league || (param === "all" && league === "");
  return (
    <li
      className={`${
        isSelect ? "active bg-primary rounded-md" : ""
      } flex-1 flex items-center justify-center link no-underline hover:bg-primary rounded-md`}
      onClick={() => window.history.replaceState(null, "", `?${params.toString()}`)}
    >
      <span className="text-nowrap hover:bg-inherit">{children}</span>
    </li>
  );
}
